import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import {WebsocketsHelperService} from './websockets-helper.service';
import {AuthenticationHelperService} from './authentication-helper.service';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class EchoHelperService {
  constructor(private authenticationHelperService: AuthenticationHelperService,
              private websocketsHelperService: WebsocketsHelperService) { }

  initEcho(): void {
    (window as any).Pusher = Pusher;
    (window as any).Echo = new Echo({
      broadcaster: 'pusher',
      key: environment.PUSHER_APP_KEY,
      cluster: environment.PUSHER_APP_CLUSTER,
      authEndpoint: environment.PUSHER_API_ENDPOINT,
      secret: environment.PUSHER_SECRET_KEY,
      auth: {
        headers: {
          Authorization: 'Bearer ' + this.authenticationHelperService.getToken,
          'X-App-ID': environment.PUSHER_APP_ID,
        },
      },
    });
    (window as any).Echo.connector.pusher.connection.bind('connected', () => {
      if (this.authenticationHelperService.isAuthenticated && (window as any).Echo.connector.pusher.connection.state === 'connected') {
        this.websocketsHelperService.listenToNotifications(this.authenticationHelperService.getUserData.id);
      } else {
        this.websocketsHelperService.disconnectFromNotificationsChannel(this.authenticationHelperService.getUserData.id);
      }
    });
    setTimeout(() => {
      if ((window as any).Echo.connector.pusher.connection.state !== 'connected') {
        this.initEcho();
      }
    }, 3000);
  }
}
